import React from 'react'
import styled from 'styled-components'
import ContainerMax from "components/shared/ContainerMax"
import ContentMax from "components/shared/ContentMax"

const ContentMaxStyled = styled(ContentMax)`
    display: flex;
    justify-content: center;
    overflow-y:scroll;
    iframe {
        width: 100%;
    }
`
const LiveScores = () => {
    return (
        <ContainerMax className="py-4">
            <ContentMaxStyled>
                <iframe src="https://cms.mubadalawtc.com/MubadalaWTC22/scoreboard.html" frameBorder="0" style={{ width: "100%", height: "120px" }} width="100%" height="120px" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
            </ContentMaxStyled>
        </ContainerMax>
    )
}

export default LiveScores
